<template>
  <div class="page-content">
    <page-template ref="differenceTemplate"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
                   :detailColumns="detailColumns"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';
  import userPower from '@/mixin/userPower'
  import date from '@/mixin/date'

  export default {
    mixins: [userPower, date],
    components: {
      pageTemplate
    },
    data() {
      return {
        // 高级搜索条件
        searchOptions: {
          simple: [
            {label: '', prop: 'orderNo', type: 'input', ifFuzzy: true, placeholder: "请输入业务单号"},
          ],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24
            },
            {label: '出库单号', prop: 'outerOrderNo', type: 'input', span: 12},
            {label: '入库单号', prop: 'enterOrderNo', type: 'input', span: 12},
            {
              label: '调出门店',
              type: 'select',
              prop: 'outerStoreId',
              data: [],
              span: 12,
              isHasAll: true,
              url: api.system.seStore,
            },
            {
              label: '调入门店',
              type: 'select',
              prop: 'enterStoreId',
              data: [],
              span: 12,
              isHasAll: true,
              url: api.system.seStore,
              defaultValue: this.$utils.getSysUser().storeId,
              hidden: this.$utils.getSysUser().storeId === null ? false : true
            },
            {
              label: '审核状态',
              prop: 'auditStatus',
              type: 'select',
              defaultValue: 10,
              data: [{label: '未审核', value: 10}, {label: '已审核', value: 20}],
              span: 12,
            }
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: '编辑',
            type: this.$utils.buttonType.tableOperate,
            code: 'update',
            callback: this.toEditPage,
            filter: (data) => {
              //返回true则不进行隐藏按钮，返回false则进行隐藏
              let flag = false;
              //console.log(this.$utils.getSysUser());
              if (this.$utils.getSysUser().storeId) {
                if (data.outerStoreId === this.$utils.getSysUser().storeId) {
                  flag = true;
                }
              } else {
                if (data.outerStoreId === -1) {
                  flag = true;
                }
              }
              if (flag && data.auditStatus === 10) {
                return true;
              } else {
                return false;
              }
            },
          },
          {
            label: '导出',
            code: 'export',
            callback: this.goodsDetailExport,
            filter: () => {
              return false
            }
          }
        ],
        // 表格信息配置
        tableOptions: {
          tableName: 'clearTable',
          showSelect: true,
          indexShow: true,//是否显示索引
          columns: [
            {label: '业务单号', prop: 'orderNo', width: '240', align: 'center', showDetail: true},
            {label: '调出门店', prop: 'outerStoreName', width: '150', align: 'center'},
            // {label: '调出仓库', prop: 'outerWarehouseName', width: '120', align: 'center'},
            {label: '调入门店', prop: 'enterStoreName', width: '150', align: 'center'},
            // {label: '调入仓库', prop: 'enterWarehouseName', width: '120', align: 'center'},
            {label: '单据金额', prop: 'billAmount', width: '120', align: 'center'},
            {
              label: '审核状态',
              prop: 'auditStatus',
              width: '120',
              align: 'center',
              enumData: this.$utils.getCacheStatus('dnAllocationOrder.auditStatus')
            },
            {label: '出库单号', prop: 'outerOrderNo', width: '210', align: 'center'},
            {label: '入库单号', prop: 'enterOrderNo', width: '210', align: 'center'},
            {label: '审核人', prop: 'reviewerName', width: '120', align: 'center'},
            {label: '审核日期', prop: 'reviewerDttm', width: '150', align: 'center'},
            {label: '备注', prop: 'remarks', width: '125', align: 'center'},
          ],
          param: {auditStatus: 10, stCreateDttm: this.getStMonthDate(), edCreateDttm: this.getEdMonthDate()},
          url: api.delivery.differenceOrder
        },
        detailColumns: {
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            },
            right: '200px',
            top: '30px',
          },
          span: 8,
          labelWidth: "130",
          columns: [
            {
              label: '差异单号',
              prop: 'orderNo',
            },
            {
              label: '调出门店',
              prop: 'outerStoreName'
            },
            {
              label: '调出仓库',
              prop: 'outerWarehouseName'
            },
            {
              label: '调入门店',
              prop: 'enterStoreName'
            },
            {
              label: '调入仓库',
              prop: 'enterWarehouseName'
            },
            {
              label: '经手人',
              prop: 'handler',
            },
            {
              label: '备注',
              prop: 'remarks',
            }],
          tablesProp: {
            allocationDifferenceOrderMapList: {
              url: api.delivery.differenceGoods + "/page",
              indexShow: true,
              height: this.detailHeight,
              tableName: "allocationDifferenceOrderMapList",
              showSummary: true,
              summaryColumns: ['outerNum', 'enterNum', 'differenceNum', 'differenceAmount'],
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  width: '180',
                  align: "center"
                },
                {
                  label: "商品名称",
                  prop: "goodsName",
                  width: '120',
                  align: "center"
                },
                {
                  label: '出库数量',
                  prop: 'outerNum',
                  align: "center"
                },
                {
                  label: '入库数量',
                  prop: 'enterNum',
                  align: "center"
                },
                {
                  label: '差异数量',
                  prop: 'differenceNum',
                  align: "center"
                },
                {
                  label: '配送价',
                  prop: 'deliveryPrice',
                  align: "center"
                },
                {
                  label: '差异金额',
                  prop: 'differenceAmount',
                  align: "center"

                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90',
                  align: "center"
                },
              ],
            }
          },
          // 打印的列表
          printTablesProp: {
            allocationDifferenceOrderMapList: {
              tableName: 'allocationDifferenceOrderMapList',
              showSummary: true,
              summaryColumns: ['outerNum', 'enterNum', 'differenceNum', 'differenceAmount'],
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  width: '180',
                  align: "center"
                },
                {
                  label: "商品名称",
                  prop: "goodsName",
                  width: '120',
                  align: "center"
                },
                {
                  label: '出库数量',
                  prop: 'outerNum',
                  align: "center"
                },
                {
                  label: '入库数量',
                  prop: 'enterNum',
                  align: "center"
                },
                {
                  label: '差异数量',
                  prop: 'differenceNum',
                  align: "center"
                },
                {
                  label: '配送价',
                  prop: 'deliveryPrice',
                  align: "center"
                },
                {
                  label: '差异金额',
                  prop: 'differenceAmount',
                  align: "center"

                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90',
                  align: "center"
                },
              ],
            },
          },
          url: api.delivery.differenceOrder
        }
      };
    },
    beforeCreate() {
      this.detailHeight = document.documentElement.clientHeight - 180 - 200
    },
    created() {
      this.$nextTick(() => {
        this.$refs['differenceTemplate'].operationSuccess();
      })
    },
    mounted() {
      if (Object.keys(this.$route.params).length > 0) {
        if (this.$route.params.customQuery) {
          let str = this.$route.params.customQuery
          this.tableOptions.param = eval('(' + str + ')')
        }
      }
      // this.$nextTick(()=>{
      //   this.tableOptions.url = api.delivery.differenceOrder
      //   this.$refs['differenceTemplate'].operationSuccess();
      // })
    },
    methods: {
      toEditPage(row) {
        this.$router.push({path: '/delivery/difference/add?id=' + row.id});
      },
    }
  };
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/page/delivery/Difference.vue